import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/site";
import { Reveal } from "./Reveal";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq" className="py-24 lg:py-32 bg-surface">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand mb-4 text-center">08 — FAQ</p>
          <h2 className="font-display font-extrabold text-navy tracking-tight text-4xl md:text-5xl text-center leading-[1.05]">
            Questions, answered.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-2xl border border-black/5 px-6">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display font-semibold text-navy hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink/60 leading-relaxed pb-5">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
